import { Component, input, output } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { Icon } from '@shared/components'
import { NAV_ITEMS } from '../../nav-items'

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, Icon],
  templateUrl: './sidebar.html',
  host: {
    '(document:keydown.escape)': 'isOpen() && close()'
  }
})
export class Sidebar {
  isOpen = input(false)
  closeRequested = output<void>()

  readonly navItems = NAV_ITEMS
  readonly currentYear = new Date().getFullYear()

  close(): void {
    this.closeRequested.emit()
  }
}
